export default {
      id: "zoom-in-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite-46b249.svg#zoom-in-usage",
      toString: function () {
        return this.url;
      }
    }